var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntellij(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M14.125 35.188L4.438 27.563 9.25 18.625 23.062 24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M44 14.688L43.25 37.813 27.875 44 18.625 38 32.125 24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2962ff",
    d: "M44 14.688L31.812 29.063 26.25 11 31.563 4.625z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ab47bc",
    d: "M34.688 19.625L23.25 37.188 7.25 43 9.813 34 13.125 22.875z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "M13.125 22.875L4 19.813 9.813 4 22.313 5.5 34.688 19.625z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M11 11H36V36H11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 31.5H23V33H14zM20.5 15.875L20.5 14 15.5 14 15.5 15.875 17 15.875 17 22.375 15.5 22.375 15.5 24.25 20.5 24.25 20.5 22.375 19.159 22.375 19.159 15.875zM25.375 24.5c-1.875 0-2.871-1.098-3.25-1.548l1.411-1.605c.255.282.964 1.028 1.839 1.028 1.125 0 1.375-1.125 1.375-1.75V14H29v6.625c0 .624 0 1.625-.75 2.625C27.725 23.95 26.5 24.5 25.375 24.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellij);
export default __webpack_public_path__ + "static/media/intellij.a75b0b6b6997e44a3c4daf47d7282651.svg";
export { ForwardRef as ReactComponent };